import { render, staticRenderFns } from "./products-add-or-update.vue?vue&type=template&id=0a9c5150&scoped=true&"
import script from "./products-add-or-update.vue?vue&type=script&lang=js&"
export * from "./products-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./products-add-or-update.vue?vue&type=style&index=0&id=0a9c5150&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9c5150",
  null
  
)

export default component.exports